import React from 'react';
import remoteFiles from '../../../../../common/remote_files';

const Landing = ({ onGetStarted }) => (
  <div className="welcome-screen">
    <div className="image-wrapper">
      <img
        src={ remoteFiles.verizon.dynamicOffer.bau.launchImage }
        alt="Background"
        className="background-image"
      />
    </div>
    <div className="message">
      <button className="button get-started" onClick={ onGetStarted }>Get Started</button>
      <p>
        By continuing, you accept Verizon’s
        { ' ' }
        <span className="pseudo-link">Terms & Conditions</span>
        { ' ' }
        and <span className="pseudo-link">Privacy Policy</span>.
        { ' ' }
        California customers can review our
        { ' ' }
        <span className="pseudo-link">California Privacy Notice</span>.
      </p>
    </div>
  </div>
);

export default Landing;
